"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Cta = _interopRequireDefault(require("../Cta"));

var _NewFeatureChip = _interopRequireDefault(require("../NewFeatureChip"));

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _useTranslation = _interopRequireDefault(require("./TranslationProvider/useTranslation"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing,
      breakpoint = _useTheme.breakpoint;

  return {
    root: (0, _defineProperty2["default"])({
      justifyContent: 'flex-start',
      minWidth: spacing(36)
    }, breakpoint.up('lg'), {
      minWidth: 'auto',
      justifyContent: 'center',
      margin: spacing(0, 1)
    }),
    primary: (0, _defineProperty2["default"])({
      justifyContent: 'center',
      alignSelf: 'center',
      margin: spacing(4, 0, 0)
    }, breakpoint.up('lg'), {
      margin: spacing(0, 1)
    }),
    "default": {},
    newFeature: {
      marginLeft: spacing(2)
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, breakpoint }}", function () {
  return [_useTheme2["default"]];
});

var Link = function Link(props) {
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      newFeature = props.newFeature,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["variant", "newFeature", "children"]);
  var type = variant === 'primary' ? 'secondary' : 'text';
  var t = (0, _useTranslation["default"])();
  var classes = useStyles();
  return (0, _core.jsx)(_Cta["default"], (0, _extends2["default"])({
    size: "md",
    css: /*#__PURE__*/(0, _css2["default"])([classes.root, classes[variant]], ";label:Link;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
    variant: type
  }, other), children, newFeature ? (0, _core.jsx)(_NewFeatureChip["default"], {
    css: classes.newFeature
  }, t('new_feature')) : null);
};

__signature__(Link, "useTranslation{t}\nuseStyles{classes}", function () {
  return [_useTranslation["default"], useStyles];
});

var _default = Link;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Link.tsx");
  reactHotLoader.register(Link, "Link", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Link.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveHeader/Link.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();